<div class="app-shell">
    <app-menu-screen></app-menu-screen>
    <app-header *ngIf="showHeader"></app-header>
    <div class="scroll-container">
        <router-outlet></router-outlet>
    </div>
    <!-- <app-bottom-nav *ngIf="showBottomNav" [cameraLink]="['/camera']" (shareClick)="openShareDetail()" [sendLink]="['/chat']"></app-bottom-nav> -->
    <app-bottom-nav *ngIf="showBottomNav" (shareClick)="openShareDetailBottomsheet()"></app-bottom-nav>
</div>